define("settings/templates/loading", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f

  var _default = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::LoadingSpinner @additionalClass="tAC--loadingSpinner" />
  */
  {
    "id": "HNQfMyRH",
    "block": "[[[8,[39,0],null,[[\"@additionalClass\"],[\"tAC--loadingSpinner\"]],null]],[],false,[\"shared/loading-spinner\"]]",
    "moduleName": "settings/templates/loading.hbs",
    "isStrictMode": false
  });

  _exports.default = _default;
});